// Compact lookup of well-known Indian cities → approx [lat, lng].
// Used as an auto-fill default for admin; admin can override per hotel.
export const CITY_COORDS = {
  // Andhra Pradesh
  "visakhapatnam": [17.6868, 83.2185], "vijayawada": [16.5062, 80.6480], "guntur": [16.3067, 80.4365],
  "tirupati": [13.6288, 79.4192], "kurnool": [15.8281, 78.0373], "kadapa": [14.4753, 78.8298],
  "nellore": [14.4426, 79.9865], "rajahmundry": [17.0005, 81.8040], "kakinada": [16.9891, 82.2475],
  "amaravati": [16.5062, 80.6480], "anantapur": [14.6819, 77.6006],
  // Arunachal Pradesh
  "itanagar": [27.0844, 93.6053], "tawang": [27.5859, 91.8594],
  // Assam
  "guwahati": [26.1445, 91.7362], "dispur": [26.1433, 91.7898], "silchar": [24.8333, 92.7789],
  "dibrugarh": [27.4728, 94.9120], "jorhat": [26.7509, 94.2037], "tezpur": [26.6528, 92.7926],
  // Bihar
  "patna": [25.5941, 85.1376], "gaya": [24.7914, 85.0002], "bhagalpur": [25.2425, 86.9842],
  "muzaffarpur": [26.1209, 85.3647], "darbhanga": [26.1542, 85.8918],
  // Chhattisgarh
  "raipur": [21.2514, 81.6296], "bhilai": [21.1938, 81.3509], "bilaspur": [22.0797, 82.1409],
  // Goa
  "panaji": [15.4909, 73.8278], "margao": [15.2832, 73.9862], "vasco da gama": [15.3960, 73.8157],
  "calangute": [15.5449, 73.7551], "candolim": [15.5163, 73.7620], "anjuna": [15.5735, 73.7400],
  "baga": [15.5556, 73.7517], "old goa": [15.5028, 73.9114],
  // Gujarat
  "ahmedabad": [23.0225, 72.5714], "surat": [21.1702, 72.8311], "vadodara": [22.3072, 73.1812],
  "rajkot": [22.3039, 70.8022], "gandhinagar": [23.2156, 72.6369], "bhavnagar": [21.7645, 72.1519],
  "jamnagar": [22.4707, 70.0577], "junagadh": [21.5222, 70.4579], "dwarka": [22.2394, 68.9678],
  "somnath": [20.8880, 70.4017], "kutch": [23.7337, 69.8597], "bhuj": [23.2530, 69.6693],
  // Haryana
  "gurgaon": [28.4595, 77.0266], "gurugram": [28.4595, 77.0266], "faridabad": [28.4089, 77.3178],
  "chandigarh": [30.7333, 76.7794], "panipat": [29.3909, 76.9635], "karnal": [29.6857, 76.9905],
  "kurukshetra": [29.9695, 76.8783], "ambala": [30.3782, 76.7767],
  // Himachal Pradesh
  "shimla": [31.1048, 77.1734], "manali": [32.2396, 77.1887], "dharamshala": [32.2190, 76.3234],
  "kullu": [31.9578, 77.1094], "solan": [30.9045, 77.0967], "kasauli": [30.8990, 76.9648],
  "dalhousie": [32.5388, 75.9707], "kufri": [31.0975, 77.2670],
  // Jharkhand
  "ranchi": [23.3441, 85.3096], "jamshedpur": [22.8046, 86.2029], "dhanbad": [23.7957, 86.4304],
  // Karnataka
  "bengaluru": [12.9716, 77.5946], "bangalore": [12.9716, 77.5946], "mysuru": [12.2958, 76.6394],
  "mysore": [12.2958, 76.6394], "mangaluru": [12.9141, 74.8560], "mangalore": [12.9141, 74.8560],
  "hubli": [15.3647, 75.1240], "belgaum": [15.8497, 74.4977], "hampi": [15.3350, 76.4600],
  "coorg": [12.3375, 75.8069], "madikeri": [12.4210, 75.7397], "udupi": [13.3409, 74.7421],
  "gokarna": [14.5474, 74.3188], "chikmagalur": [13.3161, 75.7720],
  // Kerala
  "thiruvananthapuram": [8.5241, 76.9366], "kochi": [9.9312, 76.2673], "cochin": [9.9312, 76.2673],
  "kozhikode": [11.2588, 75.7804], "calicut": [11.2588, 75.7804], "thrissur": [10.5276, 76.2144],
  "kollam": [8.8932, 76.6141], "alappuzha": [9.4981, 76.3388], "alleppey": [9.4981, 76.3388],
  "munnar": [10.0889, 77.0595], "kumarakom": [9.6178, 76.4278], "kovalam": [8.4004, 76.9787],
  "wayanad": [11.6854, 76.1320], "varkala": [8.7379, 76.7163],
  // Madhya Pradesh
  "bhopal": [23.2599, 77.4126], "indore": [22.7196, 75.8577], "gwalior": [26.2183, 78.1828],
  "jabalpur": [23.1815, 79.9864], "ujjain": [23.1793, 75.7849], "khajuraho": [24.8318, 79.9199],
  "orchha": [25.3519, 78.6420],
  // Maharashtra
  "mumbai": [19.0760, 72.8777], "pune": [18.5204, 73.8567], "nagpur": [21.1458, 79.0882],
  "nashik": [19.9975, 73.7898], "aurangabad": [19.8762, 75.3433], "solapur": [17.6599, 75.9064],
  "kolhapur": [16.7050, 74.2433], "lonavala": [18.7546, 73.4062], "mahabaleshwar": [17.9235, 73.6580],
  "shirdi": [19.7645, 74.4762], "alibaug": [18.6414, 72.8722], "matheran": [18.9866, 73.2707],
  // Manipur
  "imphal": [24.8170, 93.9368],
  // Meghalaya
  "shillong": [25.5788, 91.8933], "cherrapunji": [25.2703, 91.7325],
  // Mizoram
  "aizawl": [23.7271, 92.7176],
  // Nagaland
  "kohima": [25.6751, 94.1086], "dimapur": [25.9091, 93.7266],
  // Odisha
  "bhubaneswar": [20.2961, 85.8245], "cuttack": [20.4625, 85.8828], "puri": [19.8135, 85.8312],
  "konark": [19.8876, 86.0945], "rourkela": [22.2604, 84.8536],
  // Punjab
  "amritsar": [31.6340, 74.8723], "ludhiana": [30.9010, 75.8573], "jalandhar": [31.3260, 75.5762],
  "patiala": [30.3398, 76.3869], "mohali": [30.7046, 76.7179],
  // Rajasthan
  "jaipur": [26.9124, 75.7873], "udaipur": [24.5854, 73.7125], "jodhpur": [26.2389, 73.0243],
  "jaisalmer": [26.9157, 70.9083], "ajmer": [26.4499, 74.6399], "pushkar": [26.4899, 74.5511],
  "bikaner": [28.0229, 73.3119], "mount abu": [24.5926, 72.7156], "ranthambore": [26.0173, 76.5026],
  "chittorgarh": [24.8887, 74.6269], "bharatpur": [27.2152, 77.4977], "sawai madhopur": [26.0173, 76.3416],
  // Sikkim
  "gangtok": [27.3389, 88.6065], "pelling": [27.3160, 88.2400],
  // Tamil Nadu
  "chennai": [13.0827, 80.2707], "coimbatore": [11.0168, 76.9558], "madurai": [9.9252, 78.1198],
  "tiruchirappalli": [10.7905, 78.7047], "salem": [11.6643, 78.1460], "tirunelveli": [8.7139, 77.7567],
  "vellore": [12.9165, 79.1325], "ooty": [11.4064, 76.6932], "kodaikanal": [10.2381, 77.4892],
  "kanchipuram": [12.8342, 79.7036], "mahabalipuram": [12.6208, 80.1945], "rameswaram": [9.2876, 79.3129],
  "kanyakumari": [8.0883, 77.5385], "thanjavur": [10.7870, 79.1378], "yercaud": [11.7754, 78.2098],
  // Telangana
  "hyderabad": [17.3850, 78.4867], "warangal": [17.9689, 79.5941], "karimnagar": [18.4386, 79.1288],
  "nizamabad": [18.6725, 78.0941], "secunderabad": [17.4399, 78.4983],
  // Tripura
  "agartala": [23.8315, 91.2868],
  // Uttar Pradesh
  "lucknow": [26.8467, 80.9462], "kanpur": [26.4499, 80.3319], "agra": [27.1767, 78.0081],
  "varanasi": [25.3176, 82.9739], "prayagraj": [25.4358, 81.8463], "allahabad": [25.4358, 81.8463],
  "meerut": [28.9845, 77.7064], "noida": [28.5355, 77.3910], "ghaziabad": [28.6692, 77.4538],
  "mathura": [27.4924, 77.6737], "vrindavan": [27.5806, 77.7008], "ayodhya": [26.7922, 82.1998],
  "jhansi": [25.4484, 78.5685], "bareilly": [28.3670, 79.4304],
  // Uttarakhand
  "dehradun": [30.3165, 78.0322], "haridwar": [29.9457, 78.1642], "rishikesh": [30.0869, 78.2676],
  "nainital": [29.3919, 79.4542], "mussoorie": [30.4598, 78.0664], "ranikhet": [29.6434, 79.4322],
  "auli": [30.5330, 79.5661], "jim corbett": [29.5300, 78.7747], "corbett": [29.5300, 78.7747],
  // West Bengal
  "kolkata": [22.5726, 88.3639], "howrah": [22.5958, 88.2636], "darjeeling": [27.0410, 88.2663],
  "siliguri": [26.7271, 88.3953], "digha": [21.6270, 87.5075], "kalimpong": [27.0669, 88.4685],
  "sundarbans": [21.9497, 88.9257], "shantiniketan": [23.6786, 87.6839], "bolpur": [23.6693, 87.6842],
  // UT
  "delhi": [28.6139, 77.2090], "new delhi": [28.6139, 77.2090],
  "port blair": [11.6234, 92.7265], "havelock": [12.0311, 92.9760], "neil island": [11.8329, 93.0563],
  "kavaratti": [10.5593, 72.6358], "leh": [34.1526, 77.5771], "ladakh": [34.1526, 77.5771],
  "srinagar": [34.0837, 74.7973], "jammu": [32.7266, 74.8570], "gulmarg": [34.0483, 74.3805],
  "pahalgam": [34.0146, 75.3345], "sonamarg": [34.3061, 75.2917],
  "puducherry": [11.9139, 79.8145], "pondicherry": [11.9139, 79.8145],
  "daman": [20.4283, 72.8397], "diu": [20.7144, 70.9874], "silvassa": [20.2739, 73.0169],
};

export function lookupCityCoords(cityRaw) {
  if (!cityRaw) return null;
  const key = cityRaw.trim().toLowerCase();
  if (CITY_COORDS[key]) return CITY_COORDS[key];
  // try prefix match on multi-word cities
  for (const k of Object.keys(CITY_COORDS)) {
    if (k.startsWith(key) || key.startsWith(k)) return CITY_COORDS[k];
  }
  return null;
}
